import { render, staticRenderFns } from "./units.vue?vue&type=template&id=e813cc24&scoped=true"
import script from "./units.vue?vue&type=script&lang=js"
export * from "./units.vue?vue&type=script&lang=js"
import style0 from "./units.vue?vue&type=style&index=0&id=e813cc24&prod&lang=scss&scoped=true"
import style1 from "./units.vue?vue&type=style&index=1&id=e813cc24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e813cc24",
  null
  
)

export default component.exports